import SettingsPresets from './entities/settings-presets';
import SettingsPresetDetails from './entities/settings-preset-details';
import SettingsLanguages from './entities/settings-languages';
import SettingsRegionalAndLanguageAll from './entities/settings-regional-and-language-all';

export default {
  modules: {
    SettingsPresets,
    SettingsPresetDetails,
    SettingsLanguages,
    SettingsRegionalAndLanguageAll,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/settings/index.js